/**
 * Index of each tab in the media dialog.
 *
 * Lives here, and not next to the dialog, so that the places which navigate straight to a tab
 * — the media table's Captions chip and the media menu — can import it without a cycle back
 * into the dialog that renders them.
 *
 * They navigate by writing the number into the route, and a number gives no warning when the
 * order changes: moving Branding ahead of Caption once silently pointed both of them at the
 * wrong tab. Import from here rather than repeating the literal.
 */
export const MEDIA_TABS = {
  PREVIEW: 0,
  BRANDING: 1,
  CAPTION: 2,
  TRANSLATE: 3,
  PUBLISH: 4
};

/**
 * Attachments get their own two-tab group, which reports booleans rather than indices. Its
 * second tab is 1 regardless of where Caption sits for videos — a separate scale, named apart
 * so the two are not conflated again.
 */
export const ATTACHMENT_TABS = {
  PREVIEW: 0,
  DETAILS: 1
};



// WEBPACK FOOTER //
// ./src/constants/media-tabs.js